import React, { useState } from 'react';
import Dialog from '../../../components/Dialog';
import { IconPencil } from '../../../components/dialogIcons';

/*
  A note on one line, for whoever reviews the sheet.

  Ported onto the shared dialog shell on 5 September 2026, to Group E's approved
  drawing `dialog-note-*.png`.
*/
export default function NoteModal({ item, onSave, onClose }) {
  const [note, setNote] = useState(item.notes || '');
  return (
    <Dialog
      kind="info" icon={<IconPencil />}
      title={item.notes ? 'Edit the note on this line' : 'Note on this line'}
      record={[item.item_number_raw, item.description_raw].filter(Boolean).join(' - ')}
      onClose={onClose}
      footer={
        <>
          <button className="btn btn-quiet" onClick={onClose}>Cancel</button>
          <button className="btn btn-primary" onClick={() => onSave(item.id, note)}>Save the note</button>
        </>
      }
    >
      <div className="form-lbl" style={{ marginTop: 0 }}>Note</div>
      <textarea className="form-ta" value={note} onChange={e => setNote(e.target.value)}
        placeholder="Anything an admin should know about this line" autoFocus />
    </Dialog>
  );
}
